import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'app/components/core/Form';
import {
    useDialogContext,
    DialogChapter,
    KeyValueSummary
} from 'app/components/features/DialogWithChapters';
import { ServiceAccountSelectionField } from './ServiceAccountSelectionField.jsx';

export function SnowflakeAccountField() {
    const { t } = useTranslation();
    const context = useFormContext();
    const accountName = context.getFieldValue('account.serviceAccountName');
    const { onEditAccount } = useDialogContext();

    const summary = useMemo(() => {
        const values = { [t('common:account')]: accountName };
        return <KeyValueSummary values={values} />;
    }, [t, accountName]);

    return (
        <DialogChapter label={t('jobs:dialogs.environment.account')} summary={summary} defaultOpen>
            <ServiceAccountSelectionField onEdit={onEditAccount} />
        </DialogChapter>
    );
}
